module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0e60182f6d011d4bc8aafa86c8e0ef28.gif";